import { NgModule, ModuleWithProviders } from '@angular/core';
import { OrganizationServices } from './organization.services';
import { FileManagerService } from '../../content/common/file-manager/file-manager.service';
import { CognitoUtil } from './cognito.service';
import { CaseService } from './case.service';
import { UserService } from './user.service';
import { AuthGuard } from '../utils/auth.guard';
import { CommonService } from './common.service';
import { StripePaymentService } from './stripePayment.service';
import { CalendarEventsService } from './calendarEvent.service';
import { ReportsService } from './reports.service';
import { ApiService } from './api.service';



@NgModule({
    imports: [

    ]
})

export class CoreModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [
                OrganizationServices,
                CognitoUtil,
                AuthGuard,
                CaseService,
                UserService,
                CommonService,
                StripePaymentService,
                CalendarEventsService,
                ReportsService,
                ApiService
                
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/core-service.module.ts